import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TransportationAgency } from '../models/transportation-agency.model';
import { APIResponseWrapper } from '../models/common/api-response-wrapper';

@Injectable({
  providedIn: 'root'
})
export class TransportationAgencyService {

  private readonly http = inject(HttpClient);
  private readonly restApiUrl = `${environment.restApiUrl}transportation-agency-endpoint/`;

  addTransportationAgency(transportationAgency: TransportationAgency): Observable<APIResponseWrapper<TransportationAgency>> {
    return this.http.post<APIResponseWrapper<TransportationAgency>>(`${this.restApiUrl}transportation-agency`, transportationAgency);
  }

  findTransportationAgencyByFilter(phoneNumber?: string | null, domainEmailAccount?: string | null, agencyId?: number | null, crNumber?: number | null, motLicenseNumber?: string | null): Observable<APIResponseWrapper<TransportationAgency>> {
    const params: any = {};
    if (phoneNumber) params.phoneNumber = phoneNumber;
    if (domainEmailAccount) params.domainEmailAccount = domainEmailAccount;
    if (agencyId) params.agencyId = agencyId;
    if (crNumber) params.crNumber = crNumber;
    if (motLicenseNumber) params.motLicenseNumber = motLicenseNumber;
    
    return this.http.get<APIResponseWrapper<TransportationAgency>>(`${this.restApiUrl}transportation-agency`, { params });
  }
}
